import "angular:locale/data:de";(globalThis.$localize ??= {}).locale = "de";
